import { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import CreateAction from '../../../components/operational/createAction';
import SecondaryButton from '../../../components/ui/SecondaryButton';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import LayeredDashboardModal from '../Modals/LayeredDashboardModal';
import Publish from './Publish';
import { localeStringConverter } from '../../../helper/Converters';

const PublishTable = ({ tab }) => {


    const [published, setPublished] = useState([]);
    const [isActive, setIsActive] = useState(false)
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const getPublished = async () => {
        const response = await CreateAction({
            method: 'get',
            data: {

            },
            path: `/publishRequest`,
            showPreLoader: true,
            isFileUploading: false,
            hideToastMessages: true,
        });

        if (response?.error) return;

        setPublished(response?.result?.resultData)
        setLoading(false);
    };

    useEffect(() => {
        getPublished()
    }, [])

    const statusTemplate = column => {
        return (
            <>
                {column?.status === 'COMPLETED' || column?.status === 'PUBLISHED' ? (
                    <div className="text-[#26D39A] text-left">Onaylandı</div>
                ) :
                    (
                        <div className="text-yellow-600 text-left">Bekleniyor</div>
                    )}
            </>
        );
    };

    const sendTimeTemplate = column => {
        const date = new Date(column?.requestDate);
        return <div className="text-left">{localeStringConverter(date)}</div>;
    };


    return (
        <div>
            <div className="bg-[#f5f5f5] flex flex-col p-[20px] items-center  pb-[20px] 2lx:pb-[40px]">
                <div className="w-[100%] border rounded-[10px] bg-white p-[45px] w-[1200px]">
                    <div className="flex justify-end mb-[30px]">
                        <SecondaryButton
                            classes={'text-[14px] bg-[#6F3CE9] text-white py-[15px] px-[20px] rounded-md'}
                            onClick={() => {
                                setIsActive(true)
                            }}
                            value={'Yeni Yayınla Talebi Oluştur'}
                        />
                    </div>
                    <DataTable
                        value={published}
                        loading={loading}
                        tableStyle={{ minWidth: '50rem' }}
                        rowClassName={'cursor-pointer hover:bg-gray-50'}

                    >
                        <Column
                            header="Durum"
                            body={statusTemplate}
                            style={{ height: '50px', fontWeight: '500', fontSize: 14 }}
                        ></Column>
                        <Column
                            body={sendTimeTemplate}

                            header="Tarih"
                            style={{ height: '50px', fontWeight: '500', fontSize: 14 }}
                        ></Column>

                    </DataTable>

                </div>
            </div>
            <LayeredDashboardModal isActive={isActive}>
                <Publish
                    setIsActive={setIsActive}
                    tab={{
                        ...tab,
                        activeTabs: [...tab?.activeTabs, 'Yeni Yayınla Talebi Oluştur'],
                        activeTabTitles: [...tab?.activeTabTitles, 'Yeni Yayınla Talebi Oluştur'],
                    }}
                ></Publish>
            </LayeredDashboardModal>
        </div>
    );
};

export default PublishTable;
